import {
    ZuiIconUserSexFemale,
    ZuiIconUserSexMale,
    ZuiIconUserSexOther,
    ZuiIconUserSexTransgender,
    ZuiIconUserSexUnknown,
    ZuiIconUserUserOperator,
    ZuiIconUserUserUserUserDetails,
    ZuiIconUserUserAddUser,
    ZuiIconUserUserUser,
    ZuiIconAlertsEwiCheck,
    ZuiIconAlertsEwiInfo,
    ZuiIconAlertsEwiErrorRound,
    ZuiIconAlertsEwiQuestion,
    ZuiIconAlertsEwiWarningRound,
    ZuiIconAlertsEwiWarningTriangle,
    ZuiIconAlertsAlarmOn,
    ZuiIconImageImageDefault,
    ZuiIconFilesFolderFolder,
    ZuiIconCommonShareDefault,
    ZuiIconCommonTag,
    ZuiIconCommonDownload,
    ZuiIconCommonEditEdit,
    ZuiIconCommonDelete,
    ZuiIconCommonSearchSearch,
    ZuiIconCommonRefresh,
    ZuiIconCommonFitToScreenSize,
    ZuiIconCommonFitToExtend,
    ZuiIconCommonSettingsSettings,
    ZuiIconCommonUserManual,
    ZuiIconCommonLogout,
    ZuiIconCommonReset,
    ZuiIconSymbolsFavoriteOutlined,
    ZuiIconSymbolsFavoriteFilled,
    ZuiIconSymbolsClose,
    ZuiIconSymbolsInfo,
    ZuiIconArrowsArrowOutlineActuallyCentredLeft,
    ZuiIconArrowsArrowOutlineActuallyCentredDown,
    ZuiIconArrowsArrowOutlineActuallyCentredRight,
    ZuiIconHardwareWebcam,
    ZuiIconMediaCamDefault,
    ZuiIconMediaVideoAnalog,
    ZuiIconMediaVideoVideo,
    ZuiIconMediaPlayPlayFilled,
    ZuiIconMediaPlayPause,
    ZuiIconMediaSpeakerOn,
    ZuiIconMediaSpeakerOff,
    ZuiIconMediaVideoNextFrame,
    ZuiIconMediaVideoPreviousFrame,
    ZuiIconFilesFolderAddFolder,
} from '@zeiss/zui-react-icons'
import { withSize } from './withSizeHoc'

export const IconSexFemale = withSize(ZuiIconUserSexFemale)
export const IconSexMale = withSize(ZuiIconUserSexMale)
export const IconSexOther = withSize(ZuiIconUserSexOther)
export const IconSexTransgender = withSize(ZuiIconUserSexTransgender)
export const IconSexUnknown = withSize(ZuiIconUserSexUnknown)
export const IconUserOperator = withSize(ZuiIconUserUserOperator)
export const IconAddUser = withSize(ZuiIconUserUserAddUser)
export const IconUserDetails = withSize(ZuiIconUserUserUserUserDetails)
export const IconUser = withSize(ZuiIconUserUserUser)
export const IconEwiCheck = withSize(ZuiIconAlertsEwiCheck)
export const IconEwiInfo = withSize(ZuiIconAlertsEwiInfo)
export const IconEwiErrorRound = withSize(ZuiIconAlertsEwiErrorRound)
export const IconEwiQuestion = withSize(ZuiIconAlertsEwiQuestion)
export const IconEwiWarningRound = withSize(ZuiIconAlertsEwiWarningRound)
export const IconEwiWarningTriangle = withSize(ZuiIconAlertsEwiWarningTriangle)
export const IconBell = withSize(ZuiIconAlertsAlarmOn)
export const IconImage = withSize(ZuiIconImageImageDefault)
export const IconFolder = withSize(ZuiIconFilesFolderFolder)
export const IconShare = withSize(ZuiIconCommonShareDefault)
export const IconTag = withSize(ZuiIconCommonTag)
export const IconDownload = withSize(ZuiIconCommonDownload)
export const IconEdit = withSize(ZuiIconCommonEditEdit)
export const IconDelete = withSize(ZuiIconCommonDelete)
export const IconSearch = withSize(ZuiIconCommonSearchSearch)
export const IconRefresh = withSize(ZuiIconCommonRefresh)
export const IconFitToScreenSize = withSize(ZuiIconCommonFitToScreenSize)
export const IconFitToExtend = withSize(ZuiIconCommonFitToExtend)
export const IconSettings = withSize(ZuiIconCommonSettingsSettings)
export const IconLogout = withSize(ZuiIconCommonLogout)
export const IconUserManual = withSize(ZuiIconCommonUserManual)
export const IconReset = withSize(ZuiIconCommonReset)
export const IconFavoriteOutlined = withSize(ZuiIconSymbolsFavoriteOutlined)
export const IconFavoriteFilled = withSize(ZuiIconSymbolsFavoriteFilled)
export const IconClose = withSize(ZuiIconSymbolsClose)
export const IconInfo = withSize(ZuiIconSymbolsInfo)
export const IconArrowOutlineLeft = withSize(ZuiIconArrowsArrowOutlineActuallyCentredLeft)
export const IconArrowOutlineDown = withSize(ZuiIconArrowsArrowOutlineActuallyCentredDown)
export const IconArrowOutlineRight = withSize(ZuiIconArrowsArrowOutlineActuallyCentredRight)
export const IconWebcam = withSize(ZuiIconHardwareWebcam)
export const IconCamera = withSize(ZuiIconMediaCamDefault)
export const IconVideoFile = withSize(ZuiIconMediaVideoAnalog)
export const IconVideo = withSize(ZuiIconMediaVideoVideo)
export const IconPlayFilled = withSize(ZuiIconMediaPlayPlayFilled)
export const IconPause = withSize(ZuiIconMediaPlayPause)
export const IconSpeakerOn = withSize(ZuiIconMediaSpeakerOn)
export const IconSpeakerOff = withSize(ZuiIconMediaSpeakerOff)
export const IconVideoNextFrame = withSize(ZuiIconMediaVideoNextFrame)
export const IconVideoPreviousFrame = withSize(ZuiIconMediaVideoPreviousFrame)
export const IconAddFolder = withSize(ZuiIconFilesFolderAddFolder)
